<template>
  <div style="height: calc(100% - 40px);">
    <div style="height: 200px;background: #000;">
      <img style="width: 100%; height: 100%;object-fit: contain;" v-if="program" :src="program.pimg_path" alt />
    </div>
    <ul style="overflow-y: auto; height: calc(100% - 200px)" v-if="detail">
      <li class="win-list" v-for="(item, index) in detail.object_json" :key="item.field">
        <div style="text-align: center;height: 30px;line-height: 30px;">{{ $t('PE.Window') }}{{ index + 1 }}</div>
        <ul>
          <li v-for="m in item.wicket" :key="m.field" class="w-item">
            <div v-if="m.type == 1 || m.type == 2" class="flex-b-c">
              <div class="w-item-t">
                <!-- <span>{{ m.field_cn }} </span> -->
                <div class="ellipsis-1" style="width: 160px;height: 24px;line-height: 24px;">{{
                  m.field_item.ext_val.name }}</div>
              </div>
              <img style="width: 96px; height: 54px;object-fit: contain;" v-if="program"
                :src="m.field_item.ext_val.pimg" alt />
            </div>
            <div v-else class="flex-b-c">
              <span>{{ $t(toolsType(m.type)) }}</span>
              <img style="width: 96px; height: 54px;object-fit: contain;" v-if="program" :src="imgRequest(m.type)"
                alt />
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>

import toolsList from '@/components/schedule/windows/scripts/toolsList.js';

export default {
  name: "ProgramInfo",
  props: {
    program: {
      type: Object,
      default: () => {
        return null
      }
    }
  },
  data() {
    return {
      detail: null
    }
  },
  created() {
    this.getProgramDetail();
  },
  methods: {
    getProgramDetail() {
      // this.loading = true;
      const { play_id } = this.program;
      this.$http.post("/admin/play/detail", { play_id }, data => {
        this.detail = data;
      });
    },
    toolsType(type) {
      const list = toolsList();
      const tool = list.find(t => t.type === type);
      return tool.i18nTitle || "--";
    },
    imgRequest(type) {
      const list = toolsList();
      const tool = list.find(t => t.type === type);
      return require("./image/" + tool.image);
    }
  }
}
</script>


<style lang="scss" scoped>
.win-list {
  margin: 8px;
  background-color: #edfbff;
  border-radius: 8px;
  border: 1px solid #409EFF;
  overflow: hidden;

  .w-item {
    border-top: 1px solid #409EFF;
    padding: 4px;

    .w-item-t {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    img {
      background-color: #000;
    }
  }
}
</style>